
import * as React from "react"

const MOBILE_BREAKPOINT = 768

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean>(() => {
    // Initialize with the current window width if available
    if (typeof window !== 'undefined') {
      return window.innerWidth < MOBILE_BREAKPOINT
    }
    // Default to false when window is not available (SSR)
    return false
  })

  React.useEffect(() => {
    // Function to update state based on window size
    const updateSize = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    }

    // Add event listener
    window.addEventListener('resize', updateSize)
    
    // Call once to set the initial size
    updateSize()
    
    // Clean up event listener on component unmount
    return () => window.removeEventListener('resize', updateSize)
  }, [])

  return isMobile
}
